import api from '../../../authentication/axiosInstance';

// Shared by every Swap entry point (Site Details, Vehicle Details, Staff Details).
export const fetchStaffSwapData = async (getSetupApiPath) => {
  const [staffResponse, vehicleResponse] = await Promise.all([
    api.get(getSetupApiPath('staff/staff/')),
    api.get(getSetupApiPath('loaders/vehicles/')),
  ]);
  // Use the complete API inventory, independent of any page search or filters.
  return { staff: staffResponse.data, vehicles: vehicleResponse.data };
};

export const postStaffSwap = (getSetupApiPath, source, replacement) => api.post(
  getSetupApiPath(`staff/vehicles/${source.vehicle_id}/swap/`),
  {
    staff_id: source.staff_id,
    replacement_staff_id: replacement.staff_id,
    expected_replacement_vehicle_id: replacement.assigned_loader?.vehicle_id ?? null,
  },
);
